<app-model-viewer-artefacto
  *ngIf="enabled"
  [model-file-url]="modelFileUrl"
  [width]="width"
  [height]="height"
  [force-ar]="forceAr"
  (model-loaded)="modelLoaded($event)"
  (can-activate-ar)="onCanActivateAr($event)"
></app-model-viewer-artefacto>
